import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { LogoutIcon } from "../components/Icons";
import { Button } from "../components/ui/button";

function Settings() {
  const { logout } = useAuth();

  return (
    <>
      <h1 className="text-foreground pl-14 pt-10 text-3xl font-bold">Settings</h1>

      <div className="p-14 flex flex-col gap-10 max-w-[850px]">
        {/* Support Section */}
        <div className="neo-surface border-2 rounded-lg p-8 neo-shadow">
          <h2 className="text-foreground text-xl font-semibold mb-4">Support</h2>
          <p className="text-foreground/80">
            Need help? Contact our support team at{" "}
            <a
              href="mailto:hello@exafloplabs.com"
              className="text-main hover:opacity-80 transition-colors"
            >
              hello@exafloplabs.com
            </a>
          </p>
        </div>

        {/* Account Actions Section */}
        <div className="neo-surface border-2 rounded-lg p-8 neo-shadow">
          <h2 className="text-foreground text-xl font-semibold mb-4">
            Account Actions
          </h2>
          <Button variant="secondary" onClick={() => logout()}>
            <LogoutIcon />
            <span>Logout</span>
          </Button>
        </div>
      </div>
    </>
  );
}

export default Settings;
